module.exports = __webpack_public_path__ + "static/media/aboutimg5.aee030bc.webp";